import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlServer } from '../global_constants';
import { ServiceResponse } from '../models/service-response';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  token:any;
  pathApi:string="/v1/roles";
  urlRequestRole: string = urlServer.concat(this.pathApi);

  constructor(private http:HttpClient) {
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) {
      this.token = localStorage.getItem("token");
    } else {
      this.token = sessionStorage.getItem("token");
    }
  }

  getCompanyRoles(): Observable<ServiceResponse> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.http.get<ServiceResponse>(this.urlRequestRole,{headers: header});
  }

  getProfileRoles(uuid : String): Observable<ServiceResponse> {
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer " + this.token);
    return this.http.get<ServiceResponse>(`${this.urlRequestRole}/${uuid}`,{headers: header});
  }
  
}
